
let tokenName = 'saas_app_accessToken';

export function getToken() {
  return localStorage.getItem(tokenName);
}

export function setToken(value) {
  return localStorage.setItem(tokenName, value);
}

export function removeToken() {
  return localStorage.removeItem(tokenName);
}
